const testimonials = [
  {
    id: 1,
    quote: "TheMarketingFeeds.com transformed our online presence. Our SaaS product development was seamless and their SEO strategy doubled our organic traffic in 3 months.",
    attribution: "Sarah Johnson, CEO of TechStart",
  },
  {
    id: 2,
    quote: "The Facebook ad campaigns managed by TheMarketingFeeds.com delivered a 5x ROI compared to our previous efforts. Highly recommended!",
    attribution: "Michael Chen, Marketing Director at RetailPlus",
  },
  {
    id: 3,
    quote: "Their email campaign strategy increased our conversion rates by 40%. The team is professional, creative, and data-driven.",
    attribution: "Emma Rodriguez, E-commerce Manager at StyleHub",
  },
]

const Testimonials = () => {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Testimonials</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Why businesses choose to work with us
          </p>
        </div>
        <div className="mt-10">
          <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="relative bg-gray-50 p-6 rounded-lg">
                <svg
                  className="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-gray-200"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                >
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                <blockquote className="relative">
                  <p className="text-lg text-gray-700">{testimonial.quote}</p>
                  <footer className="mt-4">
                    <p className="text-base font-medium text-primary">{testimonial.attribution}</p>
                  </footer>
                </blockquote>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Testimonials